import { ReactNode, useRef } from "react";
import styled from "styled-components";
import * as Color from "capitalrx-components-2.0/lib/general/Color";
import { ContentChannel, useContentChannel } from "./ContentChannel";
import { BreadcrumbItems } from "./Breadcrumbs/BreadcrumbItems";
import { useLayout } from "../ContentLayout";

/** The action bars root. */
const ActionBarsRoot = styled.div`
  font-size: 14px;
  line-height: 24px;
  color: ${Color.toString(Color.DarkGrey[600])};
  position: sticky;
  z-index: 85000000;
  left: 0px;
  top: 3.5rem;

  &>.bar-container {
    box-sizing: border-box;

    &:focus {
      outline: none;
    }

    &>.bar {
      flex-direction: column;
      padding: 16px 40px;
      width: 100%;
      background-color: ${Color.toString(Color.White)};
      display: flex;
      align-items: stretch;
      border-bottom: solid 1px ${Color.toString(Color.LightGrey[200])};

      &.breadcrumbs {
        margin-bottom: 0px;
      }

      &.content {
        display: flex;
        flex-direction: column;
        
        & > div > div:first-child:not(:empty) {
          margin-top:16px;
        }
      }
    }
  }
`;

/** Displays the shell top action bars. */
export const ActionBars = (): ReactNode => {
  const actionBars = useContentChannel(null, "app-action-bars");
  const actionBarContainerRef = useRef<HTMLDivElement | null>(null);
  const layoutType = useLayout();

  if (actionBars.length === 0 || layoutType.startsWith("fullscreen")) return null;

  return (
    <ActionBarsRoot data-testid="actionbar" className="action-bar">
      <div ref={actionBarContainerRef} className="bar-container">
        <ContentChannel id="app-action-bars">
          {(children, index): JSX.Element => (
            <div key={index} className="bar">
              {index === 0 && <BreadcrumbItems />}
              <div className="content">{children}</div>
            </div>
          )}
        </ContentChannel>
      </div>
    </ActionBarsRoot>
  );
};
